// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Nmfb","info":"Note_info__3R_vZ","note":"Note_note__1wkbF","actions":"Note_actions__H-Rki"};